import type { CRPlayerCard } from '@/types/qbot';

/** Mirrored verbatim from QBot/src/shared/services/decks/deckRating.ts (WIN_CONDITIONS).
 *  Sync manually when Supercell ships a new win condition. */
export const WIN_CONDITIONS: ReadonlySet<string> = new Set([
  'hog rider', 'giant', 'golem', 'lava hound', 'royal giant',
  'balloon', 'graveyard', 'miner', 'goblin barrel', 'x-bow', 'mortar',
  'pekka', 'mega knight', 'sparky', 'royal hogs', 'electro giant',
  'ram rider', 'wall breakers', 'battle ram', 'goblin drill', 'little prince',
  'skeleton king', 'archer queen', 'golden knight', 'mighty miner', 'monk', 'boss bandit', 'goblinstein',
]);

/** Normalise a card name for win-condition matching: lower-case, strip dots
 *  (so "P.E.K.K.A" → "pekka"), trim. */
function normalise(name: string): string {
  return name.toLowerCase().replace(/\./g, '').trim();
}

export function isWinCondition(card: CRPlayerCard): boolean {
  return WIN_CONDITIONS.has(normalise(card.name));
}

/**
 * Pick the `n` most characteristic cards of a deck for the compact row: the
 * win-condition(s) first (in deck order), then the remaining cards ordered by
 * elixir cost descending (heaviest signal cards first) when `elixirCost` is
 * present, else deck order. Deterministic and pure.
 */
export function pickKeyCards(cards: CRPlayerCard[], n = 4): CRPlayerCard[] {
  const wins = cards.filter(isWinCondition);
  const rest = cards
    .filter((c) => !isWinCondition(c))
    .sort((a, b) => (b.elixirCost ?? 0) - (a.elixirCost ?? 0));
  return [...wins, ...rest].slice(0, n);
}
